import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CharterDAO } from '../../../../core/services/dao/charterDAO';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomerCaptain } from 'anchor-shared/lib/model/interface/customerInterfaces';
import { CrewMember } from 'anchor-shared/lib/model/entity/crewMember';

@Component({
  selector: 'app-customer-captain-picker',
  templateUrl: './customer-captain-picker.component.html',
  styleUrls: ['./customer-captain-picker.component.scss'],
})
export class CustomerCaptainPickerComponent implements OnInit {
  selectedCaptain: CustomerCaptain = {
    id: null,
    firstName: null,
    lastName: null,
    phoneNumber: null,
    profileAbsPath: null,
    captainCrewMemberMap: [],
  };
  selectedCrew: CrewMember = null;
  captainForm: FormGroup = new FormGroup({
    captain: new FormControl({}, []),
    crew: new FormControl({}, []),
    email: new FormControl('', [Validators.email]),
  });
  newCaptainEmail: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      captains: CustomerCaptain[];
      charterId: number;
      primaryCaptainId: number;
    },
    private charterDAO: CharterDAO,
    public dialogRef: MatDialogRef<CustomerCaptainPickerComponent>,
  ) {}

  ngOnInit() {}

  submitDisabled() {
    if (
      this.selectedCaptain?.id !== null &&
      this.selectedCaptain?.captainCrewMemberMap === null
    ) {
      return false;
    } else if (
      this.selectedCaptain?.id !== null &&
      this.selectedCaptain?.captainCrewMemberMap?.length > 0 &&
      this.selectedCrew
    ) {
      return false;
    } else if (
      this.selectedCaptain?.id !== null &&
      this.selectedCaptain?.captainCrewMemberMap?.length === 0
    ) {
      return false;
    }
    return true;
  }

  requestCaptain() {
    this.charterDAO
      .customerRequestCaptain(
        this.selectedCaptain.id,
        this.selectedCrew?.id ? this.selectedCrew.id : null,
        this.data.charterId,
        this.newCaptainEmail,
      )
      .subscribe(
        (data) => {
          console.log('Email sent!');
          this.dialogRef.close(this.selectedCaptain);
        },
        (error) => {
          console.log(error);
        },
      );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
